module.exports = __webpack_public_path__ + "static/media/texto2.5402f1cc.jpg";